import { render, staticRenderFns } from "./InfosCampanhaForm.vue?vue&type=template&id=2148709a&"
import script from "./InfosCampanhaForm.vue?vue&type=script&lang=js&"
export * from "./InfosCampanhaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports